import { render, staticRenderFns } from "./IconCompetencyRating.vue?vue&type=template&id=09feea25"
import script from "./IconCompetencyRating.vue?vue&type=script&lang=js"
export * from "./IconCompetencyRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports